class CraftParallax extends HTMLElement {
  connectedCallback() {
    this.bg = this.querySelector('[data-parallax-bg]');
    this.strength = parseFloat(this.dataset.parallaxStrength || '0');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.bg || !this.strength || this.reduceMotion) return;

    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;
    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
    const offset = (progress - 0.5) * this.strength;
    this.bg.style.transform = `translateY(${offset}px)`;
  }
}

customElements.define('craft-parallax', CraftParallax);
